import { connect } from 'react-redux';
import CommissionHistoryComponent from '../components/CommissionHistoryComponent';
import action from '../redux/actions/commission';

const mapStateToProps = (state) => ({
  commission: state.commission.commission,
  commissionByTime: state.commission.commissionByTime,
  coins: state.setting.coins,
});

const mapsDispatchToProps = (dispatch) => ({
  onFetchCommission: () => {
    dispatch(action.FetchCommission());
  },
  onFetchCommissionByTime: (params) => {
    dispatch(action.FetchCommissionRange(params));
  },
});

export default connect(mapStateToProps, mapsDispatchToProps)(CommissionHistoryComponent);
